import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, resolveLang } from '@/config';

const useLangFromQuery = (): void => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const requested = new URLSearchParams(location.search).get('lang');
    if (!requested) {
      return;
    }

    const resolved = resolveLang(requested);
    if (!(resolved in LANGUAGES) || resolved === i18n.language) {
      return;
    }

    void i18n.changeLanguage(resolved);
  }, [location.search, i18n]);
};

export default useLangFromQuery;
